export const category = [
    { id: 1, value: "All Categories" },
    { id: 2, value: "Sport" },
    { id: 3, value: "Romance" },
    { id: 4, value: "Prose" },
    { id: 5, value: "Poetry" },
    { id: 6, value: "Adventure" },
  ];